import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      masonryGrid: this.el.querySelector('.three-column-cards__masonry'),
      cards: this.el.querySelectorAll('.column-card')
    };

    this.desktopBreakpoint = 1024;

    this.masonryColumsMargin();
  }

  addListeners() {
    window.addEventListener('resize', this.masonryColumsMargin.bind(this));
  }

  masonryColumsMargin() {
    const cards = Array.from(this.dom.cards);
    let lastItemColumn1 = 0, lastItemColumn2 = 0, lastItemColumn3 = 0;
    console.log(window.innerWidth > this.desktopBreakpoint);
    if (window.innerWidth > this.desktopBreakpoint) {
      cards.forEach((card, i) => {
        if (i % 3 === 0) {
          cards[i].style.marginTop = `${lastItemColumn1}px`;
          lastItemColumn1 += cards[i].offsetHeight + 40;
          return
        }

        if ((i - 1) % 3 === 0) {
          cards[i].style.marginTop = `${lastItemColumn2}px`;
          lastItemColumn2 += cards[i].offsetHeight + 40;
          return
        }

        if ((i + 1) % 3 === 0) {
          cards[i].style.marginTop = `${lastItemColumn3}px`;
          lastItemColumn3 += cards[i].offsetHeight + 40;
          return
        }
      })
    } else {
      cards.forEach((d, i) => {
        cards[i].style.cssText = '';
      })
    }

  }
}

export default Module;
